module.exports = __webpack_public_path__ + "static/media/Intro_MedicalEquip_Text.6d946e5b.png";